var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPicture(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "@0.5xicon/photo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Core",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profiles-list---1440px",
    transform: "translate(-1263.000000, -183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list-container",
    transform: "translate(154.000000, 99.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-line",
    transform: "translate(0.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/photo",
    transform: "translate(1109.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "photo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.38,
    fill: "#000000",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 13.3333333,
    cy: 13.6666667,
    r: 3.33333333
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#FFFFFF",
    points: "11.6666667 25.3333333 20 35.3333333 3.33333333 35.3333333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-Copy",
    fill: "#FFFFFF",
    points: "25 22 35 35.3333333 15 35.3333333"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPicture);
export default __webpack_public_path__ + "static/media/no_picture.4eedaf8e3cef0d694083bec927298d17.svg";
export { ForwardRef as ReactComponent };